import { Grid, Spin } from "antd";
import { useEffect, useMemo, useState } from "react";
import {
  CountriesRevenue,
  MonthlyEarning,
  RevenueCards,
  SubscribersGrowth,
  YearlyRevenue,
} from "./components";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import {
  getEarlyRevenue,
  getTotalEarned,
  calculateContainerProperties,
} from "./helpers";
import styles from "./styles.module.scss";

const { useBreakpoint } = Grid;

export const Revenue = ({ activePlateform }) => {
  const screens = useBreakpoint();
  const [gridProperties, setGridProperties] = useState({
    maxHeight: 0,
    gap: 0,
    rowHeight: 0,
    isSm: false,
  });

  const { data: revenuYearlyGraph, isLoading: revenuYearlyGraphLoading } =
    UseApiCallForOldDashboardData({
      url: "get_revenue_graph",
      method: "POST",
      body: {
        data: "none",
      },
    });

  useEffect(() => {
    function handleGridContainer() {
      setGridProperties(calculateContainerProperties({ screens }));
    }

    handleGridContainer();

    window.addEventListener("resize", handleGridContainer);
    return () => window.removeEventListener("resize", handleGridContainer);
  }, [screens]);

  const yearlyRevenueData = useMemo(
    () => getEarlyRevenue({ revenuYearlyGraph, activePlateform }),
    [revenuYearlyGraph, activePlateform],
  );

  const { isSm: isSmallScreen, gap, maxHeight, rowHeight } = gridProperties;

  return (
    <div
      className={styles.revenueContainer}
      id="revenue-container"
      style={{
        height: screens.xxl ? maxHeight + "px" : "auto",
        gap: gap + "px",
      }}
    >
      {rowHeight ? (
        <>
          <RevenueCards height={rowHeight} activePlateform={activePlateform} />
          <div
            className={styles.secondRow}
            style={{
              height: isSmallScreen ? "auto" : rowHeight * 3 + "px",
            }}
          >
            <YearlyRevenue
              height={rowHeight * 3}
              loading={revenuYearlyGraphLoading}
              revenuYearlyGraph={yearlyRevenueData}
            />
            <MonthlyEarning
              height={rowHeight * 3}
              loading={revenuYearlyGraphLoading}
              totalEarned={getTotalEarned(yearlyRevenueData)}
            />
          </div>
          <div
            className={styles.secondRow}
            style={{ height: isSmallScreen ? "auto" : rowHeight * 3 + "px" }}
          >
            <SubscribersGrowth height={rowHeight * 3} />
            <CountriesRevenue height={rowHeight * 3} />
          </div>
        </>
      ) : (
        <div className={styles.loading}>
          <Spin />
        </div>
      )}
    </div>
  );
};
